import { DesignData, ElementAddress, MediaImage } from 'editor/src/store/design/types';
import {
  AdvancedPersonalisationElementData,
  getAdvPersoDataFromElement,
} from 'editor/src/store/plugins/utils/advPersoUtils';

export interface LinkedCollectionElement {
  element: MediaImage;
  collectionInfo: AdvancedPersonalisationElementData;
  address: ElementAddress;
}

// All collection elements carrying this linkGroupId, in design order
// (spread, then page, then element). The first entry is the group's primary.
export function getLinkedCollectionElements(designData: DesignData, linkGroupId: string): LinkedCollectionElement[] {
  const linked: LinkedCollectionElement[] = [];
  designData.spreads.forEach((spread, spreadIndex) => {
    spread.pages.forEach((page, pageIndex) => {
      page.groups.media?.forEach((element, elementIndex) => {
        const collectionInfo = getAdvPersoDataFromElement(element);
        if (collectionInfo && collectionInfo.linkGroupId === linkGroupId && element.type === 'image') {
          linked.push({ element, collectionInfo, address: { spreadIndex, pageIndex, elementIndex } });
        }
      });
    });
  });
  return linked;
}
